import Touchable from "src/components/Touchable";
import { paddingLarge, paddingSmall } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import { CommentBubbleRepliesAttachmentHeight } from "../constants";
import { CommentAttachmentType } from "../types";

const CommentAttachmentReplyCount = ({
	attachment,
	color,
}: {
	attachment: CommentAttachmentType.ReplyCount;
	color: string;
}) => {
	return (
		<Touchable
			onPress={attachment.onPress}
			containerStyle={{
				height: CommentBubbleRepliesAttachmentHeight,
			}}
		>
			<Text
				testID="CommentAttachmentReplyCount"
				semibold
				color={color}
				xs
				style={{
					paddingHorizontal: paddingLarge,
					paddingTop: paddingSmall,
				}}
			>
				{attachment.count >= 100
					? "99+ replies"
					: `${attachment.count} ${attachment.count > 1 ? "replies" : "reply"}`}
			</Text>
		</Touchable>
	);
};
export default CommentAttachmentReplyCount;
